import {
	Button,
	Container,
	Drawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
	Link,
	Stack,
	Tag,
	Image,
	useDisclosure,
} from "@chakra-ui/react";
import { __ } from "@wordpress/i18n";
import React from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../constants";
import { localized } from "../utils";
import Changelog from "./Changelog";
import { Logo } from "./Icon";
import announcement from "../images/announcement.gif";
import IntersectObserver from "./IntersectionObserver";

const Header: React.FC = () => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const ref = React.useRef<any>();
	return (
		<>
			<Stack
				direction="row"
				minH="70px"
				justify="space-between"
				px="6"
				borderBottom="1px solid #E9E9E9"
				bg="white"
				position={{
					sm: "sticky",
				}}
				top="var(--wp-admin--admin-bar--height, 0)"
				zIndex={1}
			>
				<Container maxW="container.xl">
					<Stack
						direction="row"
						minH="70px"
						justify="space-between"
						px="6"
					>
						<Stack direction="row" align="center" gap="7">
							<Link as={NavLink} to="/dashboard">
								<Logo h="10" w="10" />
							</Link>
							<IntersectObserver routes={ROUTES}>
								{ROUTES.map(({ route, label }) => (
									<Link
										data-target={route}
										key={route}
										as={NavLink}
										to={route}
										fontSize="sm"
										fontWeight="semibold"
										lineHeight="150%"
										color="#383838"
										_hover={{
											color: "primary.500",
										}}
										_focus={{
											boxShadow: "none",
										}}
										_activeLink={{
											color: "primary.500",
											borderBottom: "3px solid",
											borderColor: "primary.500",
											marginBottom: "-2px",
										}}
										display="inline-flex"
										alignItems="center"
										px="2"
										h="full"
									>
										{label}
									</Link>
								))}
							</IntersectObserver>
						</Stack>
						<Stack direction="row" align="center">
							<Tag
								variant="outline"
								colorScheme="primary"
								borderRadius="xl"
								bgColor="#F8FAFF"
							>
								{localized.version}
							</Tag>
							<Link
								href="https://wpblockart.com/magazine-blocks/pricing/?utm_medium=mgb-dashboard&utm_source=mgb-pricing&utm_campaign=magazine-blocks-update"
								color="primary.500"
								fontSize="12px"
								_hover={{ color: "primary.500" }}
								_active={{ color: "primary.500" }}
								_focus={{
									outline: "0 !important",
									boxShadow: "none",
									color: "primary.500",
								}}
								isExternal
							>
								{__("Upgrade to Pro", "magazine-blocks")}
							</Link>
							<Button
								onClick={onOpen}
								variant="unstyled"
								borderRadius="full"
								border="2px"
								borderColor="gray.200"
								w="40px"
								h="40px"
								position="relative"
							>
								<Image
									src={announcement}
									alt="announcement"
									h="35px"
									w="35px"
									position="absolute"
									top="50%"
									left="50%"
									transform="translate(-40%, -50%)"
								/>
							</Button>
						</Stack>
					</Stack>
				</Container>
			</Stack>
			<Drawer
				isOpen={isOpen}
				placement="right"
				onClose={onClose}
				finalFocusRef={ref}
			>
				<DrawerOverlay bgColor="rgba(0,0,0,0.05)" />
				<DrawerContent top="var(--wp-admin--admin-bar--height, 0) !important">
					<DrawerCloseButton />
					<DrawerHeader>
						{__("Latest Updates", "magazine-blocks")}
					</DrawerHeader>
					<DrawerBody>
						<Changelog />
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</>
	);
};

export default Header;
